import script from "./DCRegister.vue?vue&type=script&setup=true&lang=ts"
export * from "./DCRegister.vue?vue&type=script&setup=true&lang=ts"

import "./DCRegister.vue?vue&type=style&index=0&id=02642ad2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02642ad2"]])

export default __exports__